import { useNavigate } from 'react-router';

import { ChatWidget } from './ChatWidget.js';
import styles from './WidgetPreview.module.css';

/**
 * TEMPORARY fixtures preview for the floating chat widget, served at
 * /widget-preview. Renders the bespoke ChatWidget over a stub "host page" so the
 * FAB, panel, and callout can be exercised on fixtures — without disturbing the
 * real Stream/bridge WidgetView that still owns /widget. Expanding hands off to
 * the full /chat page, mirroring the host handoff. The wiring epic decides
 * whether this replaces /widget.
 */
export function WidgetPreview() {
  const navigate = useNavigate();

  return (
    <div className={styles.host}>
      <div className={styles.bar}>
        <span className={styles.brand}>Acme Corp — Dashboard</span>
        <span className={styles.badge}>Host page (stub)</span>
      </div>
      <div className={styles.body}>
        <h1 className={styles.title}>Employer dashboard</h1>
        <p className={styles.note}>
          This stands in for the host page an employer is on. The chat widget floats bottom-right —
          open it to read and reply without leaving the page, or expand to the full workspace.
        </p>
      </div>

      <ChatWidget
        onExpand={({ channelId, open, tab }) => {
          const query = [
            channelId ? `channel=${encodeURIComponent(channelId)}` : '',
            open ? `open=${open}` : '',
            tab ? `tab=${tab}` : '',
          ]
            .filter(Boolean)
            .join('&');
          navigate(query ? `/chat?${query}` : '/chat');
        }}
      />
    </div>
  );
}
